<template>
  <div class="wallet-dialog">
    <Modal
      v-model="openWalletDialog"
      class-name="wallet-modal"
      :transfer="true"
      :footer-hide="true"
      :closable="true"
      :scrollable="true"
    >
      <div class="modal-content">
        <p slot="header" class="title text-center">
          Connect Wallet
        </p>
        <div
          class="wallet-content flex justify-between items-center"
          :class="wallet == 'metamask' ? 'wallet-content-active' : ''"
          @click="selectWallet('metamask')"
        >
          <div class="logo flex items-center text-warpper">
            <img src="../../../assets/img/metamask48.svg">
            <p>MetaMask</p>
          </div>

          <div class="img-wapper">
            <img src="../../../assets/img/check-blue-24.png">
          </div>
        </div>
        <button class="connectBtn" @click="connectWallet(wallet)">
          Connect Wallet
        </button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  inject: ["reload"],
  data() {
    return {
      openWalletDialog: false,
      wallet: "",
    };
  },
  methods: {
    ...mapActions(["generateRoutes"]),
    selectWallet(wallet) {
      this.wallet = wallet;
    },
    open() {
      this.openWalletDialog = true;
    },

    connectWallet(name) {
      if (name === "metamask") {
        this.getEthAuth();
      }
    },

    // 获取metamask授权
    async getEthAuth() {
      try {
        // 请求用户授权
        const res = await window.ethereum.enable();
        this.$store.commit("changeEthAddress", res[0]);
        this.generateRoutes(res[0]);
        this.reload();
      } catch (error) {
        console.log(error);
      } finally {
        this.openWalletDialog = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.modal-content {
  .connectBtn {
    width: 100%;
    height: 48px;
    background: linear-gradient(270deg, #3f5efb 0%, #fc466b 100%);
    border-radius: 10px;
    color: #fff;
    font-size: 16px;
    outline: none;
  }
  .title {
    font-size: 24px;
    line-height: 50px;
  }
  .wallet-content {
    cursor: pointer;
    padding: 16px;
    margin-top: 15px;
    margin-bottom: 30px;
    width: 100%;
    height: 64px;
    border-radius: 6px;
    color: #fff;
    .text-warpper {
      img {
        margin-right: 16px;
      }
      p {
        font-size: 16px;
        font-weight: 500;
        line-height: 19px;
      }
    }
    .img-wapper {
      display: none;
    }
    &:hover {
      background: rgb(109, 117, 121);
    }
  }
  .wallet-content-active {
    // border: 1px solid #fff;
    .img-wapper {
      display: block;
    }
  }
  .logo {
    img {
      max-width: 32px;
    }
  }
}
</style>
